/**
 * conteoEfectivoLineas.ts — Líneas de billetes/monedas para arqueo de efectivo en ticket.
 */

import type { ConteoEfectivo } from "../types/caja.types";
import { formatTicketMoney } from "./ticketCierreFormat";

export const DENOMINACIONES_CONTEO = [
  100_000, 50_000, 20_000, 10_000, 5_000, 2_000, 1_000, 500, 200, 100, 50,
] as const;

export interface LineaConteoEfectivo {
  d: number;
  qty: number;
  sub: number;
}

export function lineasConteoEfectivo(
  conteo: ConteoEfectivo,
): LineaConteoEfectivo[] {
  return DENOMINACIONES_CONTEO.flatMap((d) => {
    const qty = conteo.denominaciones[d] || 0;
    if (!qty) return [];
    return [{ d, qty, sub: d * qty }];
  });
}

export function partitionBilletesMonedas(lineas: LineaConteoEfectivo[]): {
  bills: LineaConteoEfectivo[];
  coins: LineaConteoEfectivo[];
} {
  return {
    bills: lineas.filter((l) => l.d >= 1_000),
    coins: lineas.filter((l) => l.d < 1_000),
  };
}

/** Formato canónico: `$100.000 x 10: $1.000.000` */
export function formatLineaDenominacionConteo(
  linea: LineaConteoEfectivo,
): string {
  return `$${linea.d.toLocaleString("es-CO")} x ${linea.qty}: ${formatTicketMoney(linea.sub)}`;
}
